import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import {CARGO_HEADER_COLORS, LOCO_HEADER_COLOR} from "../GameStyleUI";
import steamIcon from "../../../images/gameplay_ui/icons/heat icon.svg";
import electroIcon from "../../../images/gameplay_ui/icons/electro icon.svg";
import {ELECTRO_TYPE, LOCO_TYPE} from "../../../constants/Constants";
import electroPic from "../../../images/gameplay_ui/illustrations/electro_pic.png";
import steamPic from "../../../images/gameplay_ui/illustrations/steam_pic.png";
import CurrencyCard from "./CurrencyCard";
import car_train_icon from "../../../images/gameplay_ui/icons/car_train_icon.svg";
import loco_icon from "../../../images/gameplay_ui/icons/loco_icon.svg";
import GameData from "../../../gameplay/model/GameData";
import {useDrag} from "react-dnd";
import GameController from "../../../gameplay/controllers/GameController";
import agent from "../../../agent";

const freeTrain = props => {
  let train = props.train;
  agent.GamePlay.freeTrain(props.teamID, {
    trainId: train.id
  }, response => console.log(response));
  GameData.CurrentGame.freeTrain(train);
  if (props.parent) props.parent.forceUpdate();
}

const TrainCard = (props) => {
  let canDrag = props.isCanFree && GameData.CurrentGame.state === 4;
  let train = props.train;
  let locoType = train.locoType;
  const [{opacity}, drag] = useDrag(() => ({
    item: {
      data: train, type: "train"
    }, collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0 : 1
    })
  }), [props.index + 1, "train"]);

  let mainStyle = {
    position: "relative", width: "100px", height: "85px", paddingRight: "10px", cursor: canDrag ? "move" : ""
  }
  let colors = LOCO_HEADER_COLOR[locoType ?? ELECTRO_TYPE];
  let content = [];

  content.push(<div style={{display: "flex"}} key={'div1'}>
    <img alt={"icon"} src={locoType === LOCO_TYPE ? steamPic : electroPic} style={{
      width: "25px", height: "25px", padding: "5px"
    }}/>
    <div style={{
      display: "flex", flexDirection: "column", justifyContent: "space-between", height: "25px", padding: "5px"

    }}>
      <CurrencyCard icon={loco_icon}
                    value={`${GameController.calcTrainWeight(props.train)}`}
                    size={10}
                    fontSize={10}
                    textColor={"black"}
      />
      <CurrencyCard icon={car_train_icon}
                    value={`${GameController.calcTrainCars(props.train)}`}
                    size={10}
                    fontSize={10}
                    textColor={"black"}
      />
    </div>
  </div>);
  let lengthIndicators = [];
  let length = train.trainType === 0 ? 5 : 10;
  let locoCount = train.trainType === 0 ? 3 : 5;
  for (let i = 0; i < length; i++) {
    if (i < locoCount) {
      if (i < train.locomotives.length) {
        let loco = GameData.CurrentGame.getLocoById(train.locomotives[i]);
        let locoColors = LOCO_HEADER_COLOR[loco.partsType];
        lengthIndicators.push(<div key={'a' + i}
                                   style={{
                                     width: "5px",
                                     height: "10px",

                                     background: `linear-gradient(180deg, ${locoColors[0]} 0%,${locoColors[1]} 100%)`,
                                     marginRight: "1px"
                                   }}>

        </div>)
      } else {
        lengthIndicators.push(<div key={'b' + i}
                                   style={{
                                     width: "5px", height: "10px", background: `#C4C4C4`, marginRight: "1px"
                                   }}>

        </div>)
      }

    } else {
      if (i - locoCount < train.carTrainPacks.length) {
        let pack = GameData.CurrentGame.getTrainCarById(train.carTrainPacks[i - locoCount]);
        let packColor = CARGO_HEADER_COLORS(pack.type);
        lengthIndicators.push(<div key={'c' + i}
                                   style={{
                                     width: "10px",
                                     height: "10px",

                                     background: `linear-gradient(180deg, ${packColor[0]} 0%,${packColor[1]} 100%)`,
                                     marginRight: "1px"
                                   }}>

        </div>)
      } else {
        lengthIndicators.push(<div key={"d" + i}
                                   style={{
                                     width: "10px", height: "10px", background: `#C4C4C4`, marginRight: "1px"
                                   }}>

        </div>)
      }
    }
  }
  content.push(<div key={"div"} style={{
    display: "flex", padding: "5px"
  }}>
    {lengthIndicators}
  </div>);

  return <div ref={canDrag ? drag : null} className={"train-card"} style={{...mainStyle, opacity: opacity}}>
    <GameWindowHeader width={100}
                      height={30}
                      isClosable={canDrag}
                      onHide={() => freeTrain(props)}
                      icon={locoType === LOCO_TYPE ? steamIcon : electroIcon}
                      title={"№ " + (train.id + 1)}
                      iconSize={20}
                      fontSize={14}
                      fontWeight={"bold"}
                      positionTop={8}
                      positionLeft={5}
                      colorStart={colors[0]}
                      colorEnd={colors[1]}
    />
    <GameWindowBg width={100} height={55} value={content}/>
  </div>;
}
export default TrainCard;
